import { Command } from "cmdk";
import { CornerDownLeft } from "lucide-react";

// ============================================================
// Primitive presentazionali della Command Palette:
// gruppo con etichetta small-caps oro + riga con icona in chip.
// Solo token tema (mai hex).
// ============================================================

export function PaletteGroup({
  heading,
  children,
}: {
  heading: string;
  children: React.ReactNode;
}) {
  return (
    <Command.Group
      heading={heading}
      className="[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:pb-1.5 [&_[cmdk-group-heading]]:pt-3 [&_[cmdk-group-heading]]:font-display [&_[cmdk-group-heading]]:text-[10px] [&_[cmdk-group-heading]]:font-semibold [&_[cmdk-group-heading]]:uppercase [&_[cmdk-group-heading]]:tracking-[0.22em] [&_[cmdk-group-heading]]:text-primary/70"
    >
      {children}
    </Command.Group>
  );
}

interface PaletteRowProps {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  /** Valore univoco per cmdk (es. "nav:/admin/tasks", "client:<uuid>"). */
  value: string;
  onSelect: () => void;
  /** Testo secondario a destra (es. cliente del preventivo, stato task). */
  meta?: string;
  hint?: string;
}

export function PaletteRow({ icon: Icon, label, value, onSelect, meta, hint }: PaletteRowProps) {
  return (
    <Command.Item
      value={value}
      onSelect={onSelect}
      className="group flex cursor-pointer items-center gap-3 rounded-lg px-2.5 py-2 text-sm transition-colors aria-selected:bg-primary/10"
    >
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-primary/20 bg-primary/10 text-primary transition-colors group-aria-selected:border-primary/40 group-aria-selected:bg-primary/20">
        <Icon className="h-3.5 w-3.5" />
      </span>
      <span className="flex-1 truncate group-aria-selected:text-primary">{label}</span>
      {meta && (
        <span className="max-w-[35%] truncate text-[11px] text-muted-foreground">{meta}</span>
      )}
      {hint && (
        <span className="hidden text-[11px] text-muted-foreground sm:inline">{hint}</span>
      )}
      <CornerDownLeft className="h-3 w-3 shrink-0 text-primary/70 opacity-0 transition-opacity group-aria-selected:opacity-100" />
    </Command.Item>
  );
}
